// Fahrzeuge, die auf Pfaden hin- und herfahren.
import * as THREE from "three"

const ahead = new THREE.Vector3()

export class Mover {
  constructor(object, points, { speed = 4, pingPong = true, offset = 0, yOffset = 0 } = {}) {
    this.object = object
    this.curve = new THREE.CatmullRomCurve3(points, false, "catmullrom", 0)
    this.length = this.curve.getLength()
    this.speed = speed
    this.pingPong = pingPong
    this.t = offset
    this.direction = 1
    this.yOffset = yOffset
    this.paused = false
  }

  update(dt) {
    if (this.paused) return
    this.t += (this.direction * this.speed * dt) / this.length
    if (this.t > 1 || this.t < 0) {
      if (this.pingPong) {
        this.direction *= -1
        this.t = THREE.MathUtils.clamp(this.t, 0, 1)
      } else {
        this.t = (this.t + 1) % 1
      }
    }
    const position = this.curve.getPointAt(this.t)
    this.object.position.set(position.x, position.y + this.yOffset, position.z)
    const next = THREE.MathUtils.clamp(this.t + this.direction * 0.01, 0, 1)
    this.curve.getPointAt(next, ahead)
    ahead.y += this.yOffset
    if (ahead.distanceToSquared(this.object.position) > 1e-6) {
      this.object.lookAt(ahead)
      this.object.rotateY(-Math.PI / 2)
    }
  }
}
